export default __webpack_public_path__ + "static/PersonWithCoins-524e50a192ce0ac1f5a8a3fecaa5325f.png";